// extracted by mini-css-extract-plugin
export var partners = "partners-module--partners--Jj66T";
export var caption = "partners-module--caption--zYs9W";
export var partner = "partners-module--partner--WN7Bs";
export var list = "partners-module--list--XFehl";